import { render } from "./PermissionLink.vue?vue&type=template&id=e1b68e6c"
import script from "./PermissionLink.vue?vue&type=script&lang=js"
export * from "./PermissionLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__